import account from './account';
import menu from './menu';
import role from './role';
import cgi from './cgi';
import jsnode from './jsnode';
import abilities from './abilities';
import wx3rd from './wx3rd';
import flow from './flow';
import poc from './poc';
import rio from './rio';
import system from './system';
import miniProgram from './mini-program';
import devtool from './devtool';
import itSelf from './it-self';
import gitlab from './gitlab';
import cdn from './cdn';
import content from './content';
import organization from './organization';
import vendor from './vendor';

const api = {
  account,
  menu,
  role,
  cgi,
  jsnode,
  abilities,
  wx3rd,
  flow,
  poc,
  rio,
  system,
  miniProgram,
  devtool,
  itSelf,
  gitlab,
  cdn,
  content,
  organization,
  vendor,
};

export default api;
